import { RootState } from "app/store"
import { connect, useDispatch } from "react-redux"
import { ITwoColumnsChooserArgs } from "widgets/two-columns-chooser/types"
import { PlayerList } from "./player-list"
import { setInternalPlayers, setActivePlayers } from "app/store/slices/editableTournament"
import { TPlayer } from "pages/PlayersPage/types"
import { useState, useCallback, SyntheticEvent, useEffect } from "react"
import { TSearchQuery } from "widgets/search-bar/types"
import styles from "./tournament-players.module.css"
import CreateIcon from 'icons/create.svg'
import { IconButton } from "entities/IconButton"
import { InputBase } from "@mui/material"
import { PlayerManipulationService } from "shared/player/services/player-manipulation-service"
import { setPlayers, setCountPlayers } from "app/store/slices/player"
import { useDebounce } from "shared/useDebaunce"

const mapStateToProps = (state: RootState) => ({
  count: state.playerSlice.count,
  tournamentPlayers: state.editableTournamentSlice.internalPlayers,
  activePlayers: state.editableTournamentSlice.activePlayers,
  tours: state.editableTournamentSlice.tours,
  wholePlayers: state.playerSlice.players,
})

const playerManipulationService = PlayerManipulationService()

export const TournamentPlayers = connect(mapStateToProps)(({ 
    count,
    tournamentPlayers,
    activePlayers,
    wholePlayers,
    tours,
}: ITwoColumnsChooserArgs) => {
    const [rowTourPlayers, setRowTourPlayers] = useState<any[]>([])
    const [addPlayers, setAddPlayers] = useState<boolean>(true)
    const [textQuery, setTextQuery] = useState('')
    const debouncedSearchTerm = useDebounce(textQuery, 500);
    
    const dispatch = useDispatch()

    const removeFromInternalPlayers = useCallback((playerId: any) => {
        dispatch(setInternalPlayers(tournamentPlayers.filter((p: TPlayer) => p.id !== undefined && p.id !== playerId)))
        dispatch(setActivePlayers(activePlayers.filter((p: TPlayer) => p.id !== undefined && p.id !== playerId)))
        /**
         * Добавить реализацию алгоритма поиска и удаления игрока из турнирной сетки 
         * Добавить реализацию алгоритма запрета на удаление игрока из турнирной сетки, если он уже играет
         */
        const remPlInd = rowTourPlayers.findIndex((p: TPlayer) => p.id !== playerId)
        setRowTourPlayers(rowTourPlayers.toSpliced(remPlInd - 1, 1))
    }, [tournamentPlayers, activePlayers, wholePlayers, setRowTourPlayers, rowTourPlayers])

    const appendToInternalPlayers = useCallback((playerId: any) => {
        if(tournamentPlayers.find((p: TPlayer) => p.id === playerId)){
            return
        }

        const newPlayer = wholePlayers.find((p: TPlayer) => p.id === playerId)
        dispatch(setInternalPlayers([...tournamentPlayers, newPlayer]))

        if(rowTourPlayers.length < 5) {
            setRowTourPlayers([...rowTourPlayers, newPlayer])
        }
    }, [tournamentPlayers, activePlayers, wholePlayers, setRowTourPlayers, rowTourPlayers])

    const onSearch = useCallback(async (res: TSearchQuery) => {
        if (!res.value || !res.field || !res.equivalence) {
          dispatch(setPlayers([]))
        }

        if (res.field && res.value && res.value !== '') {
          const {count} = await playerManipulationService.getCountPlayersField(res.field, res.value)
          dispatch(setCountPlayers(count))
          const {players} = await playerManipulationService.getPlayersField(res.field, res.value)
          dispatch(setPlayers(players || []))
        } else {
          const {count} = await playerManipulationService.getCountPlayers()
          dispatch(setCountPlayers(count))
          const {players} = await playerManipulationService.getPlayers(0, 5)
          dispatch(setPlayers(players || []))
        } 
    }, [])

    useEffect(() => {
        if (debouncedSearchTerm === "") {
            onSearch({
                value: '',
                field: '',
                equivalence: ''
            })
            return
        }
        onSearch({
            value: debouncedSearchTerm,
            field: 'name',
            equivalence: ''
        })
    }, [debouncedSearchTerm])

    return (
        <div className={styles.App}>
            <div className={styles.TourPlayers}>
                <div>Участники</div>
                <div className={styles.AddPlayers}>
                    <span>Добавить игроков</span>
                    <IconButton icon={CreateIcon} onClick={() => setAddPlayers(true)} />
                </div>
                <PlayerList players={tournamentPlayers} onDeleteClick={removeFromInternalPlayers}/>
            </div>

            {addPlayers && <div className={styles.Players}>
                <div>Игроки</div>
                <InputBase
                    placeholder={`Поиск по имени`}
                    inputProps={{ 'aria-label': 'search by name' }}
                    onChange={(e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => { setTextQuery(e.currentTarget.value) }}
                />
                <PlayerList players={wholePlayers} onAddClick={appendToInternalPlayers}/>
            </div>}
        </div>
    )
})